export const TIME_FORMAT_PREFERENCES = {
  STANDARD: 'StandardTime',
  MILITARY: 'MilitaryTime'
} as const;

export type TimeFormatPreference = (typeof TIME_FORMAT_PREFERENCES)[keyof typeof TIME_FORMAT_PREFERENCES];

export const DEFAULT_TIME_FORMAT: TimeFormatPreference = TIME_FORMAT_PREFERENCES.STANDARD;
